module.exports = __webpack_public_path__ + "img/0Q3B7497_FoamcoreMatted_MockedUp.e63bd461.jpg";